export default __webpack_public_path__ + "static/media/freeman.e98068b7.jpg";